import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class SendFormBuilder {

    public static build(formBuilder: FormBuilder): FormGroup {
        return formBuilder.group({
            file: [null, Validators.required]
        });
    }
}
